import React from 'react';
import { motion } from 'framer-motion';

export function Stamp({ children, className = '', rotate = -12, delay = 0.25, testId }: { children: React.ReactNode; className?: string; rotate?: number; delay?: number; testId?: string }) {
  return (
    <motion.div
      data-testid={testId}
      initial={{ scale: 1.9, opacity: 0, rotate }}
      animate={{ scale: 1, opacity: 0.88, rotate }}
      transition={{ duration: 0.28, delay, ease: [0.7, 0, 0.84, 0] }}
      className={`stamp ${className}`}
    >
      {children}
    </motion.div>
  );
}

export function Paperclip({ className = '' }: { className?: string }) {
  return (
    <svg className={className} width="46" height="120" viewBox="0 0 46 120" fill="none" aria-hidden>
      <path d="M14 30 V92 a9 9 0 0 0 18 0 V22 a14 14 0 0 0 -28 0 V96 a19 19 0 0 0 38 0 V36" stroke="#8d939c" strokeWidth="4.5" strokeLinecap="round" />
      <path d="M14 30 V92 a9 9 0 0 0 18 0 V22 a14 14 0 0 0 -28 0 V96 a19 19 0 0 0 38 0 V36" stroke="#e5e7ea" strokeWidth="1.5" strokeLinecap="round" transform="translate(-1 -1)" />
    </svg>
  );
}

export function Tape({ className = '' }: { className?: string }) {
  return <div className={`absolute h-7 w-28 bg-[#f3e7b3]/70 shadow-sm ${className}`} style={{ clipPath: 'polygon(3% 0, 100% 6%, 97% 100%, 0 92%)' }} />;
}

export function KraftBg() {
  return <div className="kraft absolute inset-0" />;
}
